const TOKEN_KEY = 'authorization';

export const getToken = (): string | null => sessionStorage.getItem(TOKEN_KEY);

export const setToken = (token: string): void => sessionStorage.setItem(TOKEN_KEY, token);

export const removeToken = (): void => sessionStorage.removeItem(TOKEN_KEY);

export const isAuthenticated = (): boolean => !!getToken();

/** Decode JWT payload without verifying signature (client-side only). */
export const decodeToken = (token: string): Record<string, any> | null => {
  try {
    const payload = token.split('.')[1];
    const decoded = atob(payload.replace(/-/g, '+').replace(/_/g, '/'));
    return JSON.parse(decoded);
  } catch {
    return null;
  }
};

export const getUserRole = (): string | null => {
  const token = getToken();
  if (!token) return null;
  const payload = decodeToken(token);
  // Common JWT role fields
  return payload?.role || payload?.roles?.[0] || payload?.userType || null;
};

export const isAdmin = (): boolean => {
  const role = getUserRole();
  return role === 'admin';
};

export const isVendor = (): boolean => {
  const role = getUserRole();
  return role === 'vendor' || role === 'admin';
};

export const BASE_URL = 'https://api.evcareindia.com';
